export default {
  'areas.title': 'Manage Areas',
};
